import React from "react";
import '../Home/Home.css';
import { useTranslation } from 'react-i18next';

const Comp3 = () => {
  const { t, i18n } = useTranslation();
  return (
    <>

    <div className='text-container'>
        <h3 className='title-home'>{t('comp3-title')}</h3>
        <p>{t('comp3-text-1')}</p>
        <p>{t('comp3-text-2')}</p>
        <p>{t('comp3-text-3')}</p>
        <p>{t('comp3-text-4')}</p>
        <p>{t('comp3-text-5')}<a href={i18n.language === 'en'
    ? "/Component3.xlsx" 
    : "/Componente3.xlsx"
  }
  download
  target="_blank" 
  rel="noopener noreferrer"
>
  link
</a></p>
    </div>

    </>
  );
};

export default Comp3;